import "./global.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Services from "./pages/Services";
import Engineering from "./pages/services/Engineering";
import Procurement from "./pages/services/Procurement";
import Construction from "./pages/services/Construction";
import Installation from "./pages/services/Installation";
import Leasing from "./pages/services/Leasing";
import Safety from "./pages/services/Safety";
import RoboticInspection from "./pages/services/RoboticInspection";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import CookieConsent from "./components/CookieConsent";
import InstallPrompt from "./components/InstallPrompt";
import SchemaOrgData, { organizationSchema } from "./components/SchemaOrgData";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <SchemaOrgData type="LocalBusiness" data={organizationSchema} />
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/engineering" element={<Engineering />} />
        <Route path="/services/procurement" element={<Procurement />} />
        <Route path="/services/construction" element={<Construction />} />
        <Route path="/services/installation" element={<Installation />} />
        <Route path="/services/leasing" element={<Leasing />} />
        <Route path="/services/safety" element={<Safety />} />
        <Route path="/services/robotic-inspection" element={<RoboticInspection />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    <CookieConsent />
    <InstallPrompt />
  </QueryClientProvider>
);

export default App;
